import { render } from "./expiry.component.vue?vue&type=template&id=4e0c8670"
import script from "./expiry.component.vue?vue&type=script&lang=js"
export * from "./expiry.component.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__